// removed by extract-text-webpack-plugin
module.exports = {"description":"styles__description___3Pu2W","buttons":"styles__buttons___3xMX5"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/SharedEnergy/styles.css
// module id = 3284
// module chunks = 0